// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2FeB-","upload":"Small_upload__2di5q","imageWrap":"Small_imageWrap__3y7Ui","removeBtn":"Small_removeBtn__3bOpm"};